import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isStringNotEmpty } from "../utils/objectUtils";

export const sendFirstPromoterConversion = async (affiliateConversionId, subscriptionId, saleAmount, userId, couponCode, affiliateId, testMode = false) => {
    try {
        if (isStringNotEmpty(affiliateConversionId) && isStringNotEmpty(subscriptionId)) {
            const func = httpsCallable(functions, "sendfirstpromoterconversion", { timeout: 6000000 });

            const res = await func({ affiliateConversionId, subscriptionId, saleAmount, userId, couponCode, affiliateId, testMode });

            return res.data;
        }
    } catch (err) {
        console.log(err);
    }

    return false;
};

export const sendFirstPromoterSignUp = async (userId, affiliateId, ipAddress, testMode = false) => {
    try {
        if (isStringNotEmpty(userId) && isStringNotEmpty(affiliateId)) {
            const func = httpsCallable(functions, "sendfirstpromotersignup", { timeout: 6000000 });

            const res = await func({ userId, affiliateId, ipAddress, testMode });

            return res.data;
        }
    } catch (err) {
        console.log(err);
    }

    return false;
};